export default __webpack_public_path__ + "static/media/chbox10-pressed.5a125d0e.svg";